import { render, staticRenderFns } from "./TenderCreateNew.vue?vue&type=template&id=2d12d372&"
import script from "./TenderCreateNew.vue?vue&type=script&lang=js&"
export * from "./TenderCreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports